import { useCallback, useEffect } from "react";

import { useRestaurantDetails } from "../../providers/RestaurantDetailsContext";
import { sendAxiosRequestWithRetry } from "../../../services/sendAxiosRequestWithRetry";

const useRestaurantDetailsSync = () => {
    const { setRestaurantDetails } = useRestaurantDetails();

    const syncRestaurantDetails = useCallback(async () => {
        const {
            data: restaurantDetailsRespData,
            // error: restaurantDetailsRespError
        } = await sendAxiosRequestWithRetry<CashBoxRestaurantDetailsResponse>({
            method: "get",
            url: "/restaurant/details",
        });

        if (restaurantDetailsRespData) {
            const {
                name: restaurant_name,
                logo,
                restaurant_currency_symbol,
                restaurant_can_delivery,
                restaurant_latitude,
                restaurant_longitude,
                restaurant_riderX_address,
                opening_hours,
                pickup_order_preparation_time_as_minutes,
                delivery_order_preparation_time_as_minutes,
                waiter,
            } = restaurantDetailsRespData || {};

            const {
                id: waiter_id,
                name: waiter_name = "",
                user_name: waiter_email = "",
                is_demo_mode: isDemoMode,
                permissions,
                ws_url,
            } = waiter || {};

            setRestaurantDetails({
                waiter_id,
                waiter_name,
                waiter_email,
                restaurant_name,
                restaurant_logo: logo,
                is_demo_mode: permissions?.demo_mode === false ? false : Boolean(isDemoMode),
                currency: restaurant_currency_symbol,
                pickup_preparation_time: pickup_order_preparation_time_as_minutes,
                delivery_preparation_time: delivery_order_preparation_time_as_minutes,
                ws_url,
                restaurant_can_delivery,
                restaurant_latitude,
                restaurant_longitude,
                restaurant_riderX_address,
                opening_hours,
                waiter_permissions: permissions,
            });
        }
    }, [setRestaurantDetails]);

    useEffect(() => {
        // if (restaurantDetails === undefined) {
        syncRestaurantDetails();
        // }
    }, [syncRestaurantDetails]);
};

export default useRestaurantDetailsSync;
